<template>
  <section
:class="[bem({
    titleGradient: heading.titleGradient,
    subtitleGradient: subtitle.subtitleGradient,
    centerContent: centerContent
  }), 'global-wrapper-large']">
    <!-- eslint-disable vue/no-v-html -->
    <BaseHeading v-if="heading.text" :class="$b('title')" :tag="heading.tag || 'h2'" :size="headingSize">
      <span v-html="parseText($tr(heading.text))" />
    </BaseHeading>

    <BaseHeading
v-if="subtitle && subtitle.text" :class="$b('subtitle', { 'full-width-subtitle': subtitle.fullWidth })"
      :tag="subtitle.tag || 'h3'" size="h3">
      <span v-html="parseText($tr(subtitle.text))" />
    </BaseHeading>

    <component
:is="textComponent" v-if="copy && copy.text" :class="$b('copy', { 'full-width-copy': copy.fullWidth })"
      class="Heading__copy" :tag="copy.tag || 'p'" size="body">
      <span v-html="parseText(preparedHtml)" />
    </component>
    <!-- eslint-enable vue/no-v-html -->

    <PrimaryButton v-if="cta && cta.showCta" :class="$b('cta')" :to="cta.link">
      {{ $tr(cta.text) }}
    </PrimaryButton>
  </section>
</template>

<script>
import { buildHeadingMixin } from '~/mixins/headingMixin'
import parseTextMixin from '~/mixins/parseTextMixin'

import { BaseHeading, BaseCopy } from '#components'

export default {
  name: 'HeadingRow',

  components: {
    BaseHeading,
    BaseCopy,
  },

  mixins: [
    buildHeadingMixin('heading'),
    buildHeadingMixin('copy'),
    parseTextMixin,
  ],

  props: {
    heading: {
      type: Object,
      default: () => ({}),
    },

    subtitle: {
      type: Object,
      default: () => ({}),
    },

    copy: {
      type: Object,
      default: () => ({}),
    },

    cta: {
      type: Object,
      default: () => ({}),
    },

    centerContent: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const bem = useBEM('HeadingRow')
    return { bem }
  },

  computed: {
    preparedHtml() {
      const content = this.copy.text
      return content.replace(/<p>(.*)<\/p>/g, '$1')
    },

    textComponent() {
      return this.copy.tag && this.copy.tag.match(/h[1-6]/)
        ? 'BaseHeading'
        : 'BaseCopy'
    },
  },
}
</script>

<style lang="postcss">
.HeadingRow {
  @apply flex flex-col items-start w-full;

  > :last-child {
    @apply mb-0;
  }
}

.HeadingRow__title,
.HeadingRow__subtitle,
.HeadingRow__copy {
  @apply inline-block mb-sm;
}

.HeadingRow__subtitle,
.HeadingRow__copy {
  @screen lg {
    max-width: theme('width.1/3');
  }
}

.HeadingRow__subtitle--full-width-subtitle,
.HeadingRow__copy--full-width-copy {
  @apply max-w-full;
}

.HeadingRow__copy {
  @apply whitespace-pre-line;

  a {
    @apply underline;
  }
}

.HeadingRow--title-gradient .HeadingRow__title,
.HeadingRow--subtitle-gradient .HeadingRow__subtitle {
  @apply t-gradient;

  .is-dark-chrome-theme & {
    @apply t-gradient-chrome;
  }
}

.HeadingRow--center-content {
  @apply items-center mx-auto text-center max-w-3xl;
}
</style>
